import _toConsumableArray from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { useRef } from 'react';

function useGuaranteedMemo(fn, deps) {
  var ref = useRef();

  if (!ref.current || deps.length !== ref.current.prevDeps.length || ref.current.prevDeps.map(function (v, i) {
    return v === deps[i];
  }).indexOf(false) >= 0) {
    ref.current = {
      v: fn(),
      prevDeps: _toConsumableArray(deps)
    };
  }

  return ref.current.v;
}

export { useGuaranteedMemo };